import * as React from 'react';
// Filled X glyph extracted verbatim from Figma close button (node 2415:4408).
// Source path lives in a 40x40 box spanning 13.128->26.872 (glyph 13.744px,
// arm width ~3.44px => 0.25 stroke ratio). Normalised here to a tight 24x24
// viewBox so it scales predictably and keeps the correct chunky weight.
const SvgClose = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 19.76 4.244 24 12 16.24 19.755 24 24 19.76 16.24 12 24 4.244 19.755 0 12 7.756 4.244 0 0 4.244 7.755 12Z" />
  </svg>
);
export default SvgClose;
